<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Footer links'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Footer links'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'text', width: '150px' },
                { value: 'link', width: '150px' },
                { value: 'order', width: '150px' },
                { value: 'column.title', width: '150px' },
                {
                    value: 'campuses',
                    width: '150px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'footerLinks/index',
            deleteItem: 'footerLinks/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/footer-links/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/footer-links/add');
        }
    }
};
</script>
